export function isBarryAvailableForProject(isBetaProject: boolean): boolean {
    return !isBetaProject;
}
